import { useQuery } from '@tanstack/react-query';
import { PRIVILEGES } from '@stayon/auth-core';
import { useApi } from '@/shared/api';
import { can, useAuth } from '@/shared/auth';
import { CommunicationCatalogPanel } from '../communication-catalog/CommunicationCatalogPanel';
import { useObjectDetail } from './ObjectDetailContext';

/** Bereich „Nachrichten": was Gäste dieses Objekts wann von uns bekommen. */
export function ObjectMessagesTab() {
  const { groupId } = useObjectDetail();
  const api = useApi();
  const editable = can(useAuth().user, PRIVILEGES.guestExperienceEdit);
  // Das Objekt hat der Arbeitsraum schon geladen; sein Name ist der Beispielwert für {{Objekt}}.
  const { data: group } = useQuery({
    queryKey: ['property-groups', groupId],
    queryFn: () => api.propertyGroups.get(groupId),
  });
  return (
    <CommunicationCatalogPanel groupId={groupId} editable={editable} objectName={group?.name} />
  );
}
